<div class="td-wb-dashboard-goal">
  <div class="td-wb-dashboard-goal-container td-wb-dashboard-goal-container--header">
    <div class="td-wb-dashboard-goal__header-row-field">
      <td-wb-goal-type-icon class="td-wb-dashboard-goal__header-icon"
                  [goalType]="currentGoal?.subType"
                            size="35" />
        <h3 id="td-wb-aria-lti-dashboard-goal-{{ currentGoal?.id }}"
          class="td-wb-dashboard-goal__inline-header">
        <span [innerText]="goalName"></span>
      </h3>
    </div>
    <div class="td-wb-dashboard-goal__header-row-button">
      <ng-container *ngTemplateOutlet="actionsTemplate" />
    </div>
  </div>
  @if (!goalSetupComplete) {
    <div class="td-wb-dashboard-goal-container td-wb-dashboard-goal-container--body">
      <div class="td-wb-dashboard-goal-body">
        <div class="td-wb-dashboard-goal-body__item td-wb-dashboard-goal-body__item--incomplete">
          <h4 class="td-wb-dashboard-goal__content-header"
              translate="tdWb.lti.dashboard.GOAL_INCOMPLETE"></h4>
          <p class="td-wb-dashboard-goal__content-body"
             translate="tdWb.lti.dashboard.CONTINUE_SETUP"></p>
        </div>
      </div>
      <td-wb-divider />
      <div class="td-wb-dashboard-goal-container--footer">
        <div class="td-wb-dashboard-goal__body-row-button">
          <button tdWbButton
                  tdWbButtonType="secondary"
                  [attr.aria-describedby]="'td-wb-aria-lti-dashboard-goal-'+ currentGoal?.id"
                  [tdWbHref]="goalContinueState"
                  [tdWbHrefParams]="{ goalId: currentGoal?.id }">
            <span translate="tdWb.lti.dashboard.CONTINUE"></span>
          </button>
        </div>
      </div>
    </div>
  }
  @if (checkGoalCompleteStatus()) {
    <div class="td-wb-dashboard-goal-container td-wb-dashboard-goal-container--body"
    >
      <div class="td-wb-dashboard-goal-body"
           role="table"
         [attr.aria-labelledby]="'td-wb-aria-lti-dashboard-goal-' + currentGoal?.id">
        <div class="td-wb-dashboard-goal-body__item"
             role="row">
          <td-wb-inline-icon-wrapper class="td-wb-dashboard-goal__body-row-label"
                                     role="rowheader">
            <span [id]="'td-wb-aria-lti-dashboard-status-header-' + currentGoal?.id"
                  translate="tdWb.lti.dashboard.STATUS"></span>
            <td-wb-dashboard-goals-status-tooltip class="td-wb-dashboard-goal__body-row-tooltip"
              [aria-describedby]="'td-wb-aria-lti-dashboard-status-header-' + currentGoal?.id + ' td-wb-aria-lti-dashboard-goal-'+ currentGoal?.id"
              [goalStatus]="currentGoal?.status" />
          </td-wb-inline-icon-wrapper>
          <span role="cell"
                class="td-wb-dashboard-goal__body-row-value"
                [class.td-wb-dashboard-goal__status--green]="goalStatusClass === 'td-wb-dashboard-goal__status--green'"
                [class.td-wb-dashboard-goal__status--orange]="goalStatusClass === 'td-wb-dashboard-goal__status--orange'"
                [translate]="'tdWb.lti.dashboard.status.' + currentGoal?.status"></span>
        </div>
        <div class="td-wb-dashboard-goal-body__item"
             role="row">
          <span class="td-wb-dashboard-goal__body-row-label"
                role="rowheader"
                translate="tdWb.lti.dashboard.TARGET"></span>
            @if (currentGoal?.targetAmount !== undefined) {
            <span class="td-wb-dashboard-goal__body-row-value"
                  role="cell"
              [innerText]="currentGoal?.targetAmount | tdWbCurrency: {format:'c0'}"></span>
          } @else {
            <span class="td-wb-dashboard-goal__body-row-value"
                  role="cell"
                  translate="tdWb.lti.dashboard.NO_TARGET"></span>
          }
        </div>
        <div class="td-wb-dashboard-goal-body__item"
             role="row">
          <div class="td-wb-dashboard-goal__body-row-label"
               role="rowheader">
            <span translate="tdWb.lti.dashboard.PROJECTION"></span>
          </div>
          @if (showProjectionAmount) {
            <span class="td-wb-dashboard-goal__body-row-value"
                  role="cell"
                  [innerText]="currentGoal?.projectedAmount | tdWbCurrency: {format:'c0'}"></span>
          } @else {
            <span class="td-wb-dashboard-goal__body-row-value"
                  role="cell"
                  translate="tdWb.lti.dashboard.NO_PROJECT"></span>
          }
        </div>
        <div class="td-wb-dashboard-goal-body__item"
             role="row">
          <span class="td-wb-dashboard-goal__body-row-label"
                role="rowheader"
                translate="tdWb.lti.dashboard.PORTFOLIO_VALUE"></span>
          @if (hasObjective()) {
            <span class="td-wb-dashboard-goal__body-row-value"
                  role="cell"
              [innerText]="currentGoal?.investmentObjective?.currentInvestmentAmount | tdWbCurrency"></span>
          }
        </div>
      </div>
      <td-wb-divider />
      <div class="td-wb-dashboard-goal-container--footer">
        <ng-container *ngTemplateOutlet="buttonDetailTemplate" />
      </div>
    </div>
  }
  @if (goalComplete) {
    <div class="td-wb-dashboard-goal-container td-wb-dashboard-goal-container--body"
    >
      <div class="td-wb-dashboard-goal-body td-wb-dashboard-goal-body--complete">
        <div class="td-wb-dashboard-goal-body__item td-wb-dashboard-goal-body__item--incomplete">
          <h4 class="td-wb-dashboard-goal__body-complete-header"
              translate="tdWb.lti.dashboard.CONGRATULATORY"></h4>
        </div>
        <div class="td-wb-dashboard-goal-body__item td-wb-dashboard-goal-body__item--info"
             role="table"
             [attr.aria-labelledby]="'td-wb-aria-lti-dashboard-goal-' + currentGoal?.id">
          <div class="td-wb-dashboard-goal-body__item"
               role="row">
            <div class="td-wb-dashboard-goal__body-row-label"
                 role="rowheader">
              <span id="td-wb-aria-lti-dashboard-status-complete-header"
                    translate="tdWb.lti.dashboard.STATUS"></span>
              <td-wb-dashboard-goals-status-tooltip class="td-wb-dashboard-goal__body-row-tooltip"
                                                    aria-describedby="td-wb-aria-lti-dashboard-status-complete-header"
                                                    [goalStatus]="currentGoal?.status" />
            </div>
            <span class="td-wb-dashboard-goal__body-row-value"
                  role="cell"
              [class.td-wb-dashboard-goal__status--green]="goalStatusClass === 'td-wb-dashboard-goal__status--green'"
              [class.td-wb-dashboard-goal__status--orange]="goalStatusClass === 'td-wb-dashboard-goal__status--orange'"
              [translate]="'tdWb.lti.dashboard.status.' + currentGoal?.status"></span>
          </div>
          <div class="td-wb-dashboard-goal-body__item"
               role="row">
            <span class="td-wb-dashboard-goal__body-row-label"
                  role="rowheader"
                  translate="tdWb.lti.dashboard.TARGET"></span>
            <span class="td-wb-dashboard-goal__body-row-value"
                  role="cell"
              [innerText]="currentGoal?.targetAmount | tdWbCurrency"></span>
          </div>
          <div class="td-wb-dashboard-goal-body__item"
               role="row">
            <span class="td-wb-dashboard-goal__body-row-label"
                  role="rowheader"
                  translate="tdWb.lti.dashboard.PORTFOLIO_VALUE"></span>
            <span role="cell">
              @if (hasObjective()) {
                <span class="td-wb-dashboard-goal__body-row-value"
                      [innerText]="currentGoal?.investmentObjective?.currentInvestmentAmount | tdWbCurrency">
                </span>
              }
            </span>
          </div>
        </div>
      </div>
      <div class="td-wb-dashboard-goal-container--body">
        <td-wb-divider />
        <div class="td-wb-dashboard-goal-container--footer">
          <ng-container *ngTemplateOutlet="buttonDetailTemplate" />
        </div>
      </div>
    </div>
  }
  <ng-template #confirmDelete>
    <td-wb-confirm>
      <td-wb-confirm-title translate="tdWb.lti.dashboard.CONFIRM_DELETE_HEADER" />
      <td-wb-confirm-body translate="tdWb.lti.dashboard.CONFIRM_DELETE_TEXT" />
      <td-wb-confirm-buttons>
        <td-wb-confirm-button value="no"
                              class="td-wb-dashboard-goal--delete-no">
          <span translate="tdWb.lti.dashboard.NO_OPTION"></span></td-wb-confirm-button>
        <td-wb-confirm-button value="yes"
                              buttonType="primary"
                              class="td-wb-dashboard-goal--delete-yes">
          <span translate="tdWb.lti.dashboard.YES_OPTION"></span></td-wb-confirm-button>
      </td-wb-confirm-buttons>
    </td-wb-confirm>
  </ng-template>
</div>

<ng-template #buttonDetailTemplate>
  @if (goalSetupComplete) {
    <div
      class="td-wb-dashboard-goal__body-row-buttons-container">
      <div class="td-wb-dashboard-goal__body-row-button">
        <button tdWbButton
                tdWbButtonType="primary"
                tdWbHref="page.lti.dashboard-details"
                [attr.aria-describedby]="'td-wb-aria-lti-dashboard-goal-'+ currentGoal?.id"
                [tdWbHrefParams]="{ goalId: currentGoal?.id }">
          <span translate="tdWb.lti.dashboard.VIEW_DETAILS"></span>
        </button>
      </div>
    </div>
  }
</ng-template>

<ng-template #actionsTemplate>
  <td-wb-flyout-menu #actionMenu="tdWbFlyoutMenu"
                     (open)="actionMenuToggle(true)"
                     (close)="actionMenuToggle(false)">
    <button tdWbFlyoutMenuItem
            id="td-wb-dashboard-goal-rename-button"
            (click)="renameDialog.open()">
      <div class="td-wb-dashboard-goal__flyout-item">
        <td-wb-icon iconId="edit--small" />
        <span translate="tdWb.lti.dashboard.RENAME"></span>
      </div>
    </button>
    <button tdWbFlyoutMenuItem
            [disabled]="deleteDisabled"
            id="td-wb-dashboard-goal-delete-button"
            [attr.aria-describedby]="'td-wb-aria-lti-dashboard-goal-'+ currentGoal?.id"
            (click)="onDeleteClick()">
      <div class="td-wb-dashboard-goal__flyout-item">
        <td-wb-icon iconId="close--small" />
        <span translate="tdWb.lti.dashboard.DELETE"></span>
      </div>
    </button>
  </td-wb-flyout-menu>

  <button tdWbButton
          tdWbButtonType="icon"
          class="td-wb-dashboard-goal__flyout-button"
          [attr.aria-label]="'tdWb.lti.dashboard.ACTION' | translate"
          [attr.aria-describedby]="'td-wb-aria-lti-dashboard-goal-'+ currentGoal?.id"
          [class.td-wb-dashboard-goal__flyout-button--selected]="actionMenuOpen"
          [tdWbFlyoutMenuToggle]="actionMenu"
          [tdWbFlyoutMenuToggleOverlayPosition]="['end-bottom']">
    <td-wb-icon iconId="vertical-dots"
                size="16" />
  </button>
</ng-template>

<td-wb-lti-goal-rename #renameDialog="tdWbLtiGoalRename"
                       [goal]="currentGoal"
                       (goalNameChange)="updateGoalName($event)" />
